import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { runFormPipeline } from '@next-adapter/generators/form-pipeline/pipeline.js'
import { runEntityPipeline } from '@next-adapter/generators/run-entity-pipeline.js'
import { runSinglePipeline } from '@next-adapter/generators/run-single-pipeline.js'

export function runLoadedPipeline(
  loaded: LoadedSchema,
  cwd: string,
  config: ResolvedBetterstartConfig,
  outputNamespace?: string
) {
  if (loaded.type === 'form') {
    return runFormPipeline(loaded.schema, cwd, config, {
      force: false,
      silent: true,
      outputNamespace
    })
  }

  if (loaded.type === 'single') {
    return runSinglePipeline(loaded.schema, cwd, config, {
      force: false,
      silent: true,
      outputNamespace
    })
  }

  return runEntityPipeline(loaded.schema, cwd, config, {
    force: false,
    silent: true,
    outputNamespace
  })
}
